import React, { useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router";
import {
  deleteProgrammePage,
  GetListofProgramCancelToken,
  ListProgrammeFilters,
  ProgrammesPageListCancelToken,
  ProgrammesPageListFilters,
} from "../../../services/ProgramService";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import JsPDF from "jspdf";
import "jspdf-autotable";
import { TrimText } from "../../common/TrimText";
import { Link } from "react-router-dom";
import PermissionsGate from "../../../utils/permissionGate";
import { usePermissionGuardRedirect } from "../../../hooks/usePermissionGuard";
import Swal from "sweetalert2";
import {
  RenderBrandList,
  RenderProgrammeNQF,
  RenderProgrammeType,
  RenderSchool,
} from "../../../utils/CommonGroupingItem";
import $ from "jquery";
import { handleTableScroll } from "../../../utils/commonFunction";
import axios from "axios";
import DataTableComponent from "../../common/DataTableComponent";
import { RenderLinkedProgrammeName, RenderPMCStatus, RenderWebsiteBrandTemplate } from "../../../utils/CommonStatusItems";

const ProgrammePage = () => {
  const history = useHistory();
  const [data, setData] = useState();
  const [search, setSearch] = useState("");
  const [school, setSchool] = useState({arr:[], checkObj:{}});
  const [type, setType] = useState({arr:[], checkObj:{}});
  const [NQF, setNQF] = useState({arr:[], checkObj:{}});
  const [status, setStatus] = useState({arr:[],checkObj:{}});
  const [loading, setloading] = useState(true);
  const [updateData, setUpdateData] = useState(Date.now());
  const [linkedPmcProgramme, setLinkedPmcProgramme] = useState({arr:[], checkObj:{}});
  const [linkedBrandTemplates, setLinkedBrandTemplates] = useState({arr:[], checkObj:{}});
  const [filterData, setFilterData] = useState({status : [], school : [], type:[], linkedPmcProgramme:[],linkedBrandTemplates:[],})
  const [tableState, setTableState] = useState({
    page: 1,
    perPage: 10,
    sortKey: "name",
    sortOrder: "asc",
  });
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    handleTableScroll()
  }, [loading])

  useEffect(() => {
    $(document).ready(function () {
      $(".dropdown-toggle").click(function () {
        $('.rdt_TableCell').css('z-index', 0)
        $(this).parents('.rdt_TableCell').css('z-index', 22)
      });
    });
  })

  useEffect(() => {
    const cancelTokenSources = [];

    const getProgram = async () => {
      setloading(true);
  
      cancelTokenSources.forEach(source => {
        source.cancel('New request made');
      });
  
      const source = axios.CancelToken.source();
      cancelTokenSources.push(source);

      try {
        const payload = {
          page:tableState.page,
          limit:tableState.perPage,
          key:tableState.sortKey,
          sort:tableState.sortOrder,
          search : search,
          exportStatus:"false",
          viaStatus:status.arr,
          viaSchool:school.arr,
          viaType:type.arr,
          viaProgramme: linkedPmcProgramme.arr,
          viaBrand: linkedBrandTemplates.arr,
          type_assigned : "0"
        }
        const res = await ProgrammesPageListCancelToken(payload, source.token);
        if (res.status === 200) {
          setData(res.data?.result?.data);
          setTotalRows(res.data?.result?.total)
          
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
      }finally{
        setloading(false);
      }
    };
  
    getProgram();

    return () => {
      cancelTokenSources.forEach(source => {
        source.cancel('Component unmounted');
      });
    };
  }, [updateData, tableState, school, status, search, type, NQF, linkedPmcProgramme, linkedBrandTemplates]);
  

  useEffect(() => {
    const filterSource = axios.CancelToken.source();
    const getFilters = async () =>{
      try {
        const res = await ProgrammesPageListFilters(filterSource.token);
        if(res.status==200){
          setFilterData({...res.data, status : res.data.statusListFilter, school : res.data.SchoolListFilter, linkedPmcProgramme:res.data?.getLinkedProgrammes,type:res.data?.getType, linkedBrandTemplates:res.data?.getBrands})
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
      }
    }
    
    getFilters()
    return () => {
      filterSource.cancel('Component unmounted');      
    };
  }, [updateData]);

  // redirect if user lacks view permission for programme pages
  usePermissionGuardRedirect(["pmcpview"]);
  
  const columns = useMemo(() => [
    {
      name: "Name",
      selector: "name",
      sortField: "name",
      sortable: true,
      cell: (row) => (
        <PermissionsGate
          scopes={["pmcpedit"]}
          RenderError={() => (
            <span title={row.name} className="feature-name">
              {" "}
              <span className="textLimit100">{row.name}</span>
            </span>
          )}
        >
          <Link
            to={`/websiteManagement/pages/programmes_and_short_courses/programme_pages/details/open/${row.id}`}
            title={row.name}
            className="as-text-blue curser feature-name"
          >
            <span title={row.name} className="textLimit100">
              {row.name}
            </span>
          </Link>
        </PermissionsGate>
      ),
    },
    {
      name: "Status",
      selector: "status",
      sortField: "status",
      sortable: true,
      cell: (row) =>
        row?.publish_status != null ? RenderPMCStatus(row?.publish_status).html : "-",
    },
    {
      name: "School",
      selector: "School",
      sortField: "School",
      sortable: true,
      cell: (row) =>
        row?.School ? RenderSchool(row?.School).html : "-",
    },
    {
      name: "Linked PMC Programme",
      selector: "LinkedProgrammeName",
      sortField: "LinkedProgrammeName",
      sortable: true,
      cell: (row) =>
        row.LinkedProgrammeName ? <Link
          className="as-text-blue curser feature-name"
          to={`/program-management-center/programmes/programme/open/${row.pmc_id}`}
          // onClick={() => $("#assignShortCourseOptionList").modal("hide")}
          title={row.LinkedProgrammeName}
        >
          <span className="textLimit100">{row.LinkedProgrammeName || "-"}</span>
        </Link> : "-"
    },
    {
      name: "Type",
      selector: "qualification_type",
      sortField: "qualification_type",
      sortable: true,
      cell: (row) =>
        row?.qualification_type != null ? RenderProgrammeType(row?.qualification_type).html : "-",
    },
    {
      name : "Linked Brand Templates",
      selector:"brandTemplete",
      sortField : "brandTemplete",
      cell: (row) =>{
        if (row.brandTemplete.length) {
          return (
            <>
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                {row.brandTemplete.map((d, i) => (
                  <React.Fragment key={i}>
                    {RenderWebsiteBrandTemplate(d?.templateName).html}
                  </React.Fragment>
                ))}
              </div>
            </>
          );
        } else {
          return "-";
        }
      }
    },
    {
      name: "Actions",
      selector: "",
      cell: (row) => (
        <div className="assessment-08 btn-dropdown-grp">
          <div className="as-buttons">
            <PermissionsGate
              scopes={["pmcpedit"]}
              RenderError={() => (
                <button
                  className="btn btn-primary rounded-circle"
                  title="Open"
                  disabled
                >
                  <i className="fal fa-folder-open"></i>
                </button>
              )}
            >
              <Link
                to={`/websiteManagement/pages/programmes_and_short_courses/programme_pages/details/open/${row.id}`}
                className="btn btn-primary rounded-circle"
                title="Open"
              >
                <i className="fal fa-folder-open"></i>
              </Link>
            </PermissionsGate>

            <div className="dropdown btn-dropdown-item">
              <button
                className="btn btn-primary rounded-circle dropdown-toggle"
                type="button"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                title="More"
              >
                <i className="fal fa-ellipsis-h-alt"></i>
              </button>
              <div
                className="dropdown-menu"
                aria-labelledby="dropdownMenuButton"
              >
                <PermissionsGate
                  scopes={["pmcpadd"]}
                  RenderError={() => (
                    <button
                      className="btn btn-primary rounded-circle"
                      title="Duplicate"
                      disabled
                    >
                      <i className="fal fa-copy"></i>
                    </button>
                  )}
                >
                  <Link
                    to={`/websiteManagement/pages/programmes_and_short_courses/programme_pages/details/duplicate/${row.id}`}
                    className="btn btn-primary rounded-circle"
                    title="Duplicate"
                  >
                    <i className="fal fa-copy"></i>
                  </Link>
                </PermissionsGate>
                <PermissionsGate
                  scopes={["wbspagespmcpview"]}
                  RenderError={() => (
                    <button
                      className="btn btn-primary rounded-circle"
                      title="Programme View"
                      disabled
                    >
                      <i className="fal fa-eye"></i>
                    </button>
                  )}
                >
                  <Link
                    to={`/program-management-center/exportProgramme/${row.id}`}
                    target="_blank"
                    className="btn btn-primary rounded-circle"
                    title="View Programme"
                  >
                    <i className="fal fa-eye"></i>
                  </Link>
                </PermissionsGate>

                <PermissionsGate
                  scopes={["wbspagespmcpdelete"]}
                  RenderError={() => (
                    <button
                      className="btn btn-danger rounded-circle"
                      title="Delete"
                      disabled
                    >
                      <i className="fal fa-trash-alt"></i>
                    </button>
                  )}
                >
                  <button
                    title="Delete"
                    className="btn btn-danger rounded-circle"
                    onClick={() => handleDelete(row.id)}
                  >
                    <i className="fal fa-trash-alt"></i>
                  </button>
                </PermissionsGate>
              </div>
            </div>
          </div>
        </div>
      ),
    },
  ], []);

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteProgrammePage({ id: id })
          .then((res) => {
            Swal.fire("Deleted!", "Programme has been deleted.", "success");
            setUpdateData(Date.now());
          })
          .catch((error) => console.log(error));
      }
    });
  };

  const exportData = (fileType, fileName) => {
    let exportData = [];

    const header = ["Name", "Status", "School","Linked PMC Programme","Type" ,"Linked Brand Templates"];

    Swal.fire({
      title: "File downloading",
      onOpen: function () {
          Swal.showLoading();
      },
    });

    const payload = {
      page:tableState.page,
      limit:tableState.perPage,
      key:tableState.sortKey,
      sort:tableState.sortOrder,
      search : search,
      exportStatus:"true",
      viaStatus:status.arr,
      viaSchool:school.arr,
      viaType:type.arr,
      viaProgramme: linkedPmcProgramme.arr,
      viaBrand: linkedBrandTemplates.arr,
    }

    ProgrammesPageListCancelToken(payload).then((res)=>{
      // console.log(res.data)
      exportData = res.data.result;
      exportData = exportData?.map((row) => ({
        // ...row,
        "Name": row?.name ? row?.name : "-",
        "Status": row.publish_status ? RenderPMCStatus(row.publish_status).text : "",
        "School": row.School ? RenderSchool(row.School).text : "-",
        "Linked PMC Programme" : row?.LinkedProgrammeName ? row.LinkedProgrammeName : "-",
        "Type": row.qualification_type ? RenderProgrammeType(row.qualification_type).text : "-",
        "Linked Brand Templates": row.brandTemplete.length > 0 ? row.brandTemplete.map((item)=> item.templateName).join(", ") : "-" 
      }));
      // row?.brandTemplete ? row.brandTemplete.map(item => item.templateName) : "-"
  
      if (fileType === "csv") {
        const csvString = Papa.unparse(exportData, { fields: header});
        // console.log(csvString);
        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8," });

        const blobURL = window.URL.createObjectURL(blob);

        // Create new tag for download file
        const anchor = document.createElement("a");
        anchor.download = fileName;
        anchor.href = blobURL;
        anchor.dataset.downloadurl = ["text/csv", anchor.download, anchor.href].join(":");
        anchor.click();

        // Remove URL.createObjectURL. The browser should not save the reference to the file.
        setTimeout(() => {
          // For Firefox it is necessary to delay revoking the ObjectURL
          URL.revokeObjectURL(blobURL);
        }, 1000);
        Swal.close();
      } else if (fileType === "xlsx") {
        const compatibleData = exportData.map((row) => {
          const obj = {};
          header.forEach((col, index) => {
            obj[col] = row[col];
          });
          return obj;
        });
  
        let wb = XLSX.utils.book_new();
        let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
          header,
        });
        XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
        XLSX.writeFile(wb, `${fileName}.xlsx`);
        Swal.close();
        // Returning false as downloading of file is already taken care of
        return false;
      }
      if (fileType === "pdf") {
        const compatibleData = exportData.map((row) => {
          return [
            row["Name"],
            row["Status"],
            row["School"],
            row["Linked PMC Programme"],
            row["Type"],
            row["Linked Brand Templates"]
          ];
        });
        const doc = new JsPDF();
        doc.autoTable({
          head: [header],
          body: compatibleData,
          styles: {
            minCellHeight: 10,
            minCellWidth: 5,
            halign: "left",
            // valign: "center",
            fontSize: 8,
          },
        });
        doc.save(`${fileName}.pdf`);
        Swal.close();
        return false;
      }
    }).catch((err)=>{
      console.log(err)
    })    
  };

  return (    
    <DataTableComponent
      data={data}
      columns={columns}
      loading={loading}
      search={search}
      setSearch={setSearch}
      state={tableState}
      setState={setTableState}
      totalRows={totalRows}
      exportFunction={exportData}
      exportFileName={"Programme pages"}    
      filters={[
        {
            filterName: "Status",
            optionArr: filterData.status,
            state: status,
            setState: setStatus,
            renderLabelFunction: RenderPMCStatus,
        },
        {
          filterName: "School",
          optionArr: filterData.school,
          state: school,
          setState: setSchool,
          renderLabelFunction : RenderSchool
        },
        {
          filterName: " Linked PMC Programme",
          optionArr: filterData.linkedPmcProgramme,
          state: linkedPmcProgramme,
          setState: setLinkedPmcProgramme,
          // renderLabelFunction : RenderLinkedProgrammeName
        },
        {
          filterName: "Type",
          optionArr: filterData.type,
          state: type,
          setState: setType,
          renderLabelFunction: RenderProgrammeType,
        },
        {
          filterName: "Linked Brand Templates",
          optionArr: filterData.linkedBrandTemplates,
          state: linkedBrandTemplates,
          setState: setLinkedBrandTemplates,
          isOptionReversed:false,
          stopOptionSorting:true
        },
        
      ]}                
      tableButton={[
        <PermissionsGate
          RenderError={() => (
            <button
              className="btn btn-primary"
              title="Create New"
              disabled
            >
              <i className="fal fa-plus"></i>Create New
            </button>
          )}
          scopes={["wbspagespmcpadd"]}
        >
          <Link
            to={`/websiteManagement/pages/programmes_and_short_courses/programme_pages/details/create`}
          >
            <button className="btn btn-primary" title="Create New">
              <i className="fal fa-plus"></i>Create New
            </button>
          </Link>
        </PermissionsGate>
      ]}
    /> 
  );
};

export default ProgrammePage;
